module.exports = __webpack_public_path__ + "static/media/6b.29c45956.svg";